import {Component} from "@angular/core";

@Component({
    selector: "fui-statements",
    styleUrls: ["./statements.component.scss"],
    templateUrl: "./statements.component.html",
    standalone: false
})
export class FUIStatementsComponent {
    constructor() {

    }
}
